import { PreloadingStrategy, Route } from '@angular/router';
import { EMPTY, Observable, switchMap } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ProfileStore } from 'app/state-management/profile/profile.store';

@Injectable({ providedIn: 'root' })
export class AppRoutingPreloadStrategy implements PreloadingStrategy {
  private readonly hasDigilogLicense$: Observable<boolean> = toObservable(inject(ProfileStore).hasDigilogLicense);

  preload(route: Route, fn: () => Observable<unknown>): Observable<unknown> {
    switch (route?.path) {
      // cases here that loaded only for user with Digilog license
      case 'spare-parts':
      case 'incidents':
        return this.hasDigilogLicense$.pipe(
          switchMap((isDigilogLicenseActive: boolean) => isDigilogLicenseActive ? fn() : EMPTY),
        );
      default:
        return fn();
    }
  }
}
